import {logger} from "@root/server/client/esweb/src/logger.ts";
import Debug from 'debug';

const debug = Debug('app:ws');

let ws: WebSocket | null = null;

const emitter = new EventTarget();

const signedChannelToSubCnt: Record<string, number> = {};

export function subscribe(signedChannel: string, cb: (event: CustomEvent) => void) {
    signedChannelToSubCnt[signedChannel] ??= 0;
    signedChannelToSubCnt[signedChannel]++;

    if(ws?.readyState === WebSocket.OPEN && signedChannelToSubCnt[signedChannel] === 1) {
        ws.send(JSON.stringify({type: 'subscribe', signedChannel}));
    }

    if (!ws) {
        //connection should be created with first subscriber
        connect();
    }

    emitter.addEventListener(signedChannel, cb);
    return () => {
        unsubscribe(signedChannel);
        emitter.removeEventListener(signedChannel, cb);
    }
}

function unsubscribe(signedChannel: string) {
    if(!signedChannelToSubCnt[signedChannel]) {
        logger.error(`unsubscribing from already ${signedChannelToSubCnt[signedChannel]} channel ${signedChannel}`);
        return;
    }

    signedChannelToSubCnt[signedChannel]--;

    if(!signedChannelToSubCnt[signedChannel]) {
        delete signedChannelToSubCnt[signedChannel];
    }

    if(ws?.readyState === WebSocket.OPEN && !signedChannelToSubCnt[signedChannel]) {
        ws.send(JSON.stringify({type: 'unsubscribe', signedChannel}));
    }

    if (!Object.keys(signedChannelToSubCnt).length) {
        ws.close();
        ws = null;
    }
}


setInterval(() => {
    if (ws?.readyState === WebSocket.CLOSED) {
        connect();
    }
}, 10000);


function connect() {
    debug('calling connect');
    ws = new WebSocket(`${window.clientConfig.WS_PUBLIC_URL}/ws?${new URLSearchParams({token: window.clientConfig.WS_CONNECT_JWT})}`);
    debug('connection created');
    ws.onopen = () => {
        Object.entries(signedChannelToSubCnt).forEach(([signedChannel, cnt]) => {
            ws.send(JSON.stringify({type: 'subscribe', signedChannel}));
        })
        debug('Connection established.');
    };

    ws.onmessage = (event) => {
        try {
            const obj = JSON.parse(event.data);
            const {signedChannel} = obj;
            debug('dispatching', obj);
            emitter.dispatchEvent(new CustomEvent(signedChannel, {detail: obj}));
        } catch (e) {
            logger.error(e, event);
        }
    };

    ws.onclose = () => {
        debug('Connection closed.');
    };

    ws.onerror = (e) => {
        logger.error('Client error:', e);
    };
}





